<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1"><div class="section level2" id="prologue-1">
<div style="float:left; width:550px;">
<p style=" "><img alt="" src="media/img1.PNG" style="width:550px; height:850px;"/></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0015.vue?d7576bfc